import {Action} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {log} from "@dp-instant/utils";
import {TypesGame} from "@game/TypesGame";
import {BotPresetsModel} from "@game/coregame/model/BotPresetsModel";
import {inject, injectable} from "inversify";

@injectable()
export class UpdateBotLevelAction extends Action {
    @inject(TypesSocial.model)
    protected readonly social: ISocial;

    @inject(TypesGame.botPresetsModel)
    protected botPresetsModel: BotPresetsModel;

    async execute(win = false): Promise<void> {
        if (this.social.inSolo) {
            await this.updateBot(win);
        } else {
            log.warn("Bot level updates only in solo mode.");
        }
    }

    protected async updateBot(win: boolean) {
        this.botPresetsModel.updateBotLevel(win);
    }
}
